import $ from "jquery";
import BD_Block from "@bd-core/bd-block";
import bdapi from "@bd-core/bd-api";
import bdjs from "@bd-core/bdjs";
import BD_GAME_LOGIC from "@bd-core/game-logic";
import CONFIG from "@bd-core/config";
import {
  Chart,
  CategoryScale,
  LinearScale,
  BarElement,
  BarController,
} from "chart.js";
import { doAction, applyFilters } from "@bd-core/bd-hooks";
import { compile } from "@bd-utils/handlerbars-helper";
import { NuclearQuickscan } from "../../nuclear-quickscan";

export class Block_Result_Categories extends BD_Block {
  constructor() {
    super();

    this.type = "result_categories_score";
    this.templateID = "result-categories-score";
    this._serverSide = true;

    this.elms = {
      finishButton: "#finishButton",
      shareLinkedinButton: "#share-linkedin",
    };

    this._events = this.getEvents();

    /* custom attributes */
    this.audio = false;

    // @ts-ignore
    if (window.isShareLinkedin) {
      this.beforeInit();
    }
  }

  getEvents() {
    const elms = this.elms;
    return [
      {
        event: "click",
        selector: elms.finishButton,
        handler: this.onFinish,
      },
      {
        event: "click",
        selector: elms.shareLinkedinButton,
        handler: this.onShareLinkedin,
      },
    ];
  }

  beforeInit() {
    const blockParamID = this.getUrlParameter("blockID");

    if (blockParamID) return;
    this.render();
    this.setGameState();
  }

  render() {
    let templateID = this.templateID;
    if (CONFIG.siteSetup === "nuclear-quickscan") {
      templateID = "nuclear-quickscan-result-categories-score";
    }
    const htmlTemplate = $("#" + templateID).html();

    const params = new URLSearchParams(window.location.search);
    // @ts-ignore
    const endpoint = window.isShareLinkedin
      ? "public/get-results-categories-score-by-id?gp-id=" + params.get("gp-id")
      : "game/get-results-categories-score";

    bdapi
      .post(endpoint)
      .then((res) => {
        const resData = res.data;
        const data = resData.data;

        const resultAndData = {
          ...data,
          ...this._data,
          // @ts-ignore
          isShareLinkedin: !!window.isShareLinkedin,
          gp: CONFIG.GP,
        };

        const html = compile(htmlTemplate, resultAndData);
        $("#templateWrapper").html(html);

        if (CONFIG.siteSetup === "nuclear-quickscan") {
          NuclearQuickscan(resultAndData.categories);
        } else {
          doAction("after-fetch-result-categories");

          let printChart = this.printChart;
          printChart = applyFilters("print-chart", printChart);
          printChart(data);
        }

        bdjs.hideLoading();
      })
      .catch(() => {});
  }

  printChart(data) {
    const $el = document.getElementById("resultChart");
    if (!$el) return;

    Chart.register(CategoryScale, LinearScale, BarElement, BarController);

    var categories = data.categories;
    // @ts-ignore
    let ctx = $el.getContext("2d");

    const max = Math.max.apply(
      Math,
      categories.map(function (o) {
        return o.max_score;
      }),
    );

    new Chart(ctx, {
      type: "bar",
      data: {
        labels: categories.map((row) => row.name),
        datasets: [
          {
            label: data.strings.label,
            data: categories.map((row) => row.score),
            backgroundColor: categories.map((row) => row.color),
            borderColor: categories.map((row) => row.color),
            borderWidth: 1,
          },
        ],
      },
      options: {
        indexAxis: "y",
        maintainAspectRatio: false,
        responsive: true,
        plugins: {
          legend: {
            display: false,
          },
        },
        scales: {
          x: {
            beginAtZero: true,
            max,
          },
        },
        // ticks: {
        //     precision: 0
        // }
      },
    });
  }

  getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split("&"),
      sParameterName,
      i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split("=");

      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined
          ? true
          : decodeURIComponent(sParameterName[1]);
      }
    }
    return false;
  }

  setGameState() {}

  /* ========= ELEMENT FUNCTION HANDLER ===============*/

  onFinish() {
    $("#finishButton").attr("disabled", "disabled");
    BD_GAME_LOGIC.goToDefaultNextBlock();
  }

  onShareLinkedin() {
    const shareLinkedinText = $("#share-linkedin span").text();
    $("#share-linkedin span").text("Please wait...");
    $(".btn-share-linkedin").addClass("is-loading");
    $(".btn").prop("disabled", true);

    // const params = new URLSearchParams(window.location.search);
    const endpoint =
      "member/screenshot-result-categories-score?gp-id=" + CONFIG.GP;
    bdapi
      .post(endpoint)
      .then(() => {
        const url = this._data.share_linkedin_url + CONFIG.GP;
        // console.log("url", url);
        window.location.href = url;
      })
      .catch(() => {
        alert("Failed to share");
      })
      .then(() => {
        $("#share-linkedin span").text(shareLinkedinText);
        $(".btn-share-linkedin").removeClass("is-loading");
        $(".btn").prop("disabled", false);
      });
  }
}
